import React from "react"
import { useEffect, useRef } from "react"

const TTMiddleBg = () => {
  const ttPageMiddleBgRef = useRef(null)

  //get the parent container and set position to relative and z-index to 0
  //this will allow the bubbles to be behind the content
  useEffect(() => {
    const parent = ttPageMiddleBgRef.current.parentElement
    parent.style.position = "relative"
    parent.style.zIndex = 0
  }, [])

  {/* Middle Gradient background: absolutely positioned to the middle of TTVideoBanner section */}
  return (
    <div 
      ref={ttPageMiddleBgRef}
      className="absolute bottom-[10%] left-0 w-full h-full bg-gradient_tt_sections"
    />
  );
};

export default TTMiddleBg;